export enum AlanButtonPopupEditorModes {
    Preview = 'Preview',
    FullScreen = 'FullScreen',
}